import RevisionActivitiesContainer from "./RevisionActivitiesContainer";
export default RevisionActivitiesContainer;
